<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Editais</h1>
                                    <p class="modern-subtitle">Pesquise editais de licitações públicas por termo, data, estado e modalidade</p>
                                </div>
                                <div class="header-actions">
                                    <ManualFerramenta :name="'Manual Editais'"
                                                      :btnClass="'btn-manual-tool'"
                                                      :nameBtn="'Manual'"
                                                      :urlPdf="'/manuais/FERRAMENTA EDITAIS PDF.pdf'" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="page-container">
                        <div class="search-card">
                            <div class="search-box">
                                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                                <input type="text"
                                       class="modern-search-input"
                                       ref="dsTermo"
                                       placeholder="Pesquise por editais…"
                                       aria-label="Pesquisa principal"
                                       v-model="pesquisa.dsTermo"
                                       @keydown.enter="buscar" />
                            </div>

                            <div class="filters-grid">
                                <div class="filter-group">
                                    <label class="filter-label" for="dtInicial">Desde a data</label>
                                    <input type="date"
                                           id="dtInicial"
                                           class="form-control"
                                           v-model="pesquisa.dtInicial" />
                                </div>

                                <div class="filter-group">
                                    <label class="filter-label" for="dtFinal">Até a data</label>
                                    <input type="date"
                                           id="dtFinal"
                                           class="form-control"
                                           v-model="pesquisa.dtFinal" />
                                </div>

                                <div class="filter-group">
                                    <label class="filter-label" for="nmEstado">Estado (UF)</label>
                                    <select class="form-control" id="nmEstado" v-model="pesquisa.nmEstado">
                                        <option value="">Selecione</option>
                                        <option :value="item" v-for="(item, index) in lstEstados" :key="index">{{ item }}</option>
                                    </select>
                                </div>

                                <div class="filter-checks">
                                    <label class="filter-label">Filtros</label>
                                    <label class="check-item">
                                        <input class="check-input" type="checkbox" v-model="pesquisa.chkPesquisaSustentavel" />
                                        <span>Pesquisa sustentável</span>
                                    </label>
                                    <label class="check-item">
                                        <input class="check-input" type="checkbox" v-model="pesquisa.chkApenasSRP" />
                                        <span>Apenas SRP</span>
                                    </label>
                                </div>
                            </div>

                            <button class="modern-btn modern-btn-primary btn-buscar" @click="buscar">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                                Buscar Editais
                            </button>
                        </div>

                        <div class="results-section">
                            <div class="results-header">
                                <h2 class="results-title">Resultados da pesquisa</h2>
                                <span class="results-query" v-if="dataAjax">
                                    "{{ dataAjax.dsTermo ? dataAjax.dsTermo : '—' }}"
                                </span>
                            </div>

                            <template v-if="!flResultados">
                                <div class="empty-state">
                                    <div class="empty-content">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1z" />
                                            <path d="M4.5 12.5A.5.5 0 0 1 5 12h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5m0-2A.5.5 0 0 1 5 10h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5m0-2A.5.5 0 0 1 5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5" />
                                        </svg>
                                        <h3 class="empty-title">Encontre editais de licitação</h3>
                                        <p class="empty-description">
                                            Use o campo de busca acima para pesquisar por editais públicos. Filtre por período, estado e modalidade para resultados mais precisos.
                                        </p>
                                        <p class="empty-hint">Dica: pesquise por "computadores" ou "serviços de limpeza"</p>
                                    </div>
                                </div>
                            </template>

                            <Grid url_ajax="/Edital/Get"
                                  :is_table="false"
                                  :reload="reload"
                                  :ajax_set_result="setEdital"
                                  :ajax_set_count="setCount"
                                  :data_ajax="getDataAjax()"
                                  :qtd_registros_por_pagina="20">
                                <template v-slot:rows="{ rows }">
                                    <div v-if="rows.length === 0 && flResultados" class="empty-state empty-state--compact">
                                        <div class="empty-content">
                                            <h3 class="empty-title">Nenhum registro encontrado</h3>
                                            <p class="empty-description">Nenhum resultado para esta pesquisa.</p>
                                        </div>
                                    </div>

                                    <div v-else class="cards-list">
                                        <div class="result-card"
                                             v-for="(item, index) in rows"
                                             :key="index"
                                             @click="irParaDetalhe(item, index)">
                                            <div class="result-card__body">
                                                <div class="result-card__meta">
                                                    <span class="result-badge">{{ item.modalidade }}</span>
                                                    <span class="result-chip">{{ item.ufEntidade }}</span>
                                                    <span class="result-date">{{ formatDate(item.dataLicitacao) }}</span>
                                                </div>
                                                <h3 class="result-card__title">{{ item.entidade }}</h3>
                                                <p class="result-card__text">{{ item.objeto }}</p>
                                            </div>
                                            <div class="result-card__cta">
                                                Ver edital
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modais></Modais>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Modais from '@/components/Modais';
    import Grid from '@/components/Ferramentas/Grid';
    import ManualFerramenta from '@/components/Ferramentas/ManualFerramenta';
    import { avisoErro } from '@/config/global'
    import moment from 'moment'

    export default {
        name: 'Editais',
        components: { Header, Modais, Grid, ManualFerramenta },

        computed: {
            user() {
                return this.$store.state.user
            },
        },

        data() {
            return {
                pesquisa: {
                    dsTermo: null,
                    dtInicial: null,
                    dtFinal: null,
                    nmEstado: '',
                    chkPesquisaSustentavel: false,
                    chkApenasSRP: false,
                },

                lstEstados: [
                    'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO',
                    'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
                    'RJ', 'RN', 'RO', 'RS', 'RR', 'SC', 'SE', 'SP', 'TO',
                ],

                lstResultados: [],
                flResultados: false,
                reload: 0,
                dataAjax: null,
                idPesquisaEditais: null,
            }
        },

        methods: {
            load() { },

            buscar() {
                let $this = this;
                if ($this.validarBuscar()) {
                    $this.dataAjax = Object.assign({}, $this.pesquisa);
                    if ($this.dataAjax.dtInicial != null && $this.dataAjax.dtInicial !== '') {
                        $this.dataAjax.dtInicial = moment($this.dataAjax.dtInicial).format('DD/MM/YYYY');
                    }
                    if ($this.dataAjax.dtFinal != null && $this.dataAjax.dtFinal !== '') {
                        $this.dataAjax.dtFinal = moment($this.dataAjax.dtFinal).format('DD/MM/YYYY');
                    }
                    $this.dataAjax.qtdRegistrosPorPagina = 20;
                    $this.dataAjax.nrPaginaAtual = 0;
                    $this.reload = $this.reload + 1;
                }
            },

            setCount(resData) {
                return resData.data.rows.itensCount;
            },

            setEdital(data) {
                window.scrollTo({ top: 400, behavior: 'smooth' });
                const lista = data.rows?.itens ?? [];
                this.lstResultados = lista;
                this.flResultados = true;
                this.idPesquisaEditais = data.idPesquisaEditais;
                return this.lstResultados;
            },

            irParaDetalhe(item, index) {
                const state = {
                    edital: JSON.parse(JSON.stringify(item)),
                }
                history.replaceState({ ...history.state, ...state }, '')
                this.$router.push({
                    name: 'DetalheEdital',
                    query: {
                        idPesquisaEditais: this.idPesquisaEditais,
                        index: index,
                    },
                }, () => {
                    history.replaceState({ ...history.state, ...state }, '')
                })
            },

            getDataAjax() {
                return this.dataAjax;
            },

            validarBuscar() {
                let $this = this;
                if ($this.pesquisa.dsTermo == null || $this.pesquisa.dsTermo.length < 3) {
                    avisoErro('O campo "Busca" deve conter ao menos 3 caracteres');
                    return false;
                }

                if (
                    $this.pesquisa.dtInicial != '' && $this.pesquisa.dtInicial != null &&
                    $this.pesquisa.dtFinal != '' && $this.pesquisa.dtFinal != null
                ) {
                    const dtInicial = moment($this.pesquisa.dtInicial);
                    const dtFinal = moment($this.pesquisa.dtFinal);
                    if (dtInicial > dtFinal) {
                        avisoErro('A data inicial deve ser menor que a data final.');
                        return false;
                    }
                }

                return true;
            },

            formatDate(dt) {
                return moment(dt).format('DD/MM/YYYY HH:mm');
            },
        },

        mounted() {
            this.load();
        },
    };
</script>

<style lang="scss" scoped>
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        flex: 0 0 auto;
        text-align: left;
        max-width: 640px;
        min-width: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    :deep(.btn-manual-tool) {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        min-height: 42px;
        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%) !important;
        color: #fff !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    :deep(.btn-manual-tool:hover) {
        background: linear-gradient(135deg, #4b5563 0%, #374151 100%) !important;
        transform: translateY(-2px);
    }

    .page-container {
        max-width: 1140px;
        margin: 0 auto;
        padding: 24px 16px 48px;
    }

    .search-card {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border: 1px solid rgba(31, 123, 255, 0.1);
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        padding: 24px;
        margin-bottom: 28px;
    }

    [data-bs-theme="dark"] .search-card {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .search-box {
        position: relative;
        margin-bottom: 20px;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
        color: #1f2937;
    }

    .modern-search-input:focus {
        outline: none;
        border-color: #2563eb;
        background: white;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

    .filters-grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr auto;
        gap: 16px;
        align-items: end;
        margin-bottom: 20px;
    }

    .filter-label {
        display: block;
        font-size: 12px;
        font-weight: 700;
        color: #6b7280;
        letter-spacing: .04em;
        text-transform: uppercase;
        margin-bottom: 6px;
    }

    .form-control {
        border-radius: 10px;
        border: 2px solid #e5e7eb;
        background-color: #ffffff;
        padding: 10px 14px;
        font-size: 14px;
        color: #1f2937;
        min-height: 42px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .form-control:focus {
        border-color: #2563eb;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        background-color: #ffffff;
    }

    [data-bs-theme="dark"] .form-control {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

    select.form-control {
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .filter-checks {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .check-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #1f2937;
        cursor: pointer;
        user-select: none;
    }

    [data-bs-theme="dark"] .check-item {
        color: #e5e7eb;
    }

    .check-input {
        width: 16px;
        height: 16px;
        accent-color: #2563eb;
        cursor: pointer;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 42px;
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

    .modern-btn-primary:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
    }

    .btn-buscar {
        width: 100%;
    }

    .results-header {
        display: flex;
        align-items: baseline;
        gap: 12px;
        flex-wrap: wrap;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e5e7eb;
    }

    [data-bs-theme="dark"] .results-header {
        border-bottom-color: #374151;
    }

    .results-title {
        font-size: 20px;
        font-weight: 800;
        color: #1f2937;
        margin: 0;
        letter-spacing: -0.3px;
    }

    [data-bs-theme="dark"] .results-title {
        color: #f9fafb;
    }

    .results-query {
        font-size: 14px;
        font-weight: 600;
        color: #2563eb;
    }

    .empty-state {
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        border: 1px dashed #e5e7eb;
        border-radius: 12px;
        padding: 64px 24px;
        text-align: center;
    }

    .empty-state--compact {
        padding: 40px 24px;
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #cbd5e1;
    }

    .empty-title {
        font-size: 20px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    .empty-description {
        font-size: 15px;
        color: #6b7280;
        margin: 0;
        max-width: 460px;
        line-height: 1.6;
    }

    .empty-hint {
        font-size: 13px;
        font-weight: 600;
        color: #2563eb;
        margin: 8px 0 0;
    }

    .cards-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .result-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        background: #fff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        padding: 18px 20px;
        cursor: pointer;
        transition: transform .2s, box-shadow .2s, border-color .2s;
    }

    .result-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(31, 123, 255, 0.12);
        border-color: rgba(37, 99, 235, 0.35);
    }

    [data-bs-theme="dark"] .result-card {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

    .result-card__body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-width: 0;
    }

    .result-card__meta {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
    }

    .result-badge {
        display: inline-flex;
        width: fit-content;
        background: rgba(37, 99, 235, 0.1);
        color: #1d4ed8;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        padding: 4px 12px;
        border-radius: 20px;
    }

    .result-chip {
        display: inline-flex;
        font-size: 12px;
        font-weight: 700;
        color: #6b7280;
        background: #f3f4f6;
        padding: 4px 10px;
        border-radius: 20px;
    }

    [data-bs-theme="dark"] .result-chip {
        background: #111827;
        color: #9ca3af;
    }

    .result-date {
        font-size: 12px;
        color: #6b7280;
    }

    .result-card__title {
        font-size: 16px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
        line-height: 1.35;
    }

    [data-bs-theme="dark"] .result-card__title {
        color: #f9fafb;
    }

    .result-card__text {
        font-size: 13px;
        color: #6b7280;
        line-height: 1.6;
        margin: 0;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .result-card__cta {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 700;
        color: #2563eb;
        white-space: nowrap;
        flex-shrink: 0;
    }

    :deep(.grid-app .btn-navegacao) {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
        border: none !important;
        border-radius: 10px !important;
        font-weight: 600;
        padding: 8px 16px;
        color: #fff !important;
    }

    @media (max-width: 991px) {
        .filters-grid {
            grid-template-columns: 1fr 1fr;
        }

        .filter-checks {
            grid-column: span 2;
            flex-direction: row;
            gap: 20px;
        }

        .result-card__cta {
            display: none;
        }
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 20px 0;
        }

        .header-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .title-section {
            max-width: 100%;
        }

        .modern-title {
            font-size: 24px;
        }
    }

    @media (max-width: 575px) {
        .filters-grid {
            grid-template-columns: 1fr;
        }

        .filter-checks {
            grid-column: span 1;
        }

        .search-card {
            padding: 16px;
        }
    }
</style>
